import './home.css';
import { useContext } from 'react';
import { UserContext } from '../context/UserContext';

export default function HowItWorksAPN() {
  const { user } = useContext(UserContext);
  const steps = [
    {
      title: 'Bewerbung & Registrierung',
      desc: 'Du startest mit einer Registrierung und gibst uns einen ersten Einblick in dich, deinen Kanal und deine Motivation. Wir möchten verstehen, wer du bist und wohin du möchtest.',
      chips: ['Profil','Kanal','Motivation']
    },
    {
      title: 'Review & Auswahl',
      desc: 'Unser Team prüft, ob deine Werte, Ziele und deine Art zu arbeiten zu unserem Netzwerk passen. Dabei gilt: Qualität vor Quantität. Wir suchen Creator, die positiv, motiviert, respektvoll und bereit sind, sich einzubringen.',
      chips: ['Qualität vor Quantität','Teamgeist','Respekt','Aktive Mitwirkung']
    },
    {
      title: 'Onboarding – Dein Start im AP‑Network',
      desc: 'Wenn du ausgewählt wirst, erhältst du Zugang zu unserem Onboarding‑Bereich. Dort führen wir dich Schritt für Schritt durch die wichtigsten Grundlagen und richten alles gemeinsam ein. Der Abschluss wird mit einer kleinen Starthilfe (z. B. Bonus) gewürdigt.',
      chips: [
        'Account‑Verknüpfungen (Twitch/YouTube)','Fairness & Wochenlogik','Support‑Mechanismen','Lurker‑Client','Profil & Sichtbarkeit','Regeln & Verhaltenskodex','Erste Orientierung','Starthilfe‑Bonus'
      ]
    },
    {
      title: 'Anwärter‑Phase (Probezeit)',
      desc: 'Nach dem Onboarding wirst du automatisch Anwärter. Diese Phase dient einem beidseitigen Kennenlernen: Du erlebst die Community authentisch und stressfrei; wir sehen, wie aktiv und respektvoll du mitwirkst.',
      chips: ['Dashboard','Streamplan','Events','Community‑Chat','Wissensdatenbank','Mentor (optional)','Profil gestalten','mind. 7 Tage','verlängerbar']
    },
    {
      title: 'Abschlussgespräch & Entscheidung',
      desc: 'Gemeinsam mit Mentor und Admin‑Team gibt es eine kurze Feedbackrunde. Entscheidung auf Basis von Aktivität, Haltung und Integration: Aufnahme (Admin‑Mehrheit), Verlängerung der Anwärter‑Phase oder Ablehnung mit Begründung. Ziel ist Passung auf beiden Seiten – Verbindlichkeit statt Beliebigkeit.',
      chips: ['Feedbackrunde','Admin‑Mehrheit','Aufnahme','Verlängerung','Begründete Ablehnung']
    },
    {
      title: 'Aufnahme & Start als offizielles Mitglied',
      desc: 'Bei Aufnahme erhältst du die Rolle „Creator / Streamer“, Zugang zu allen Bereichen & Funktionen, Teilnahme an Projekten, Kooperationen & Events, ein Aufnahme‑Achievement; bisherige Punkte bleiben erhalten. Mentor‑Unterstützung kann auf Wunsch fortgeführt werden.',
      chips: ['Rolle: Creator/Streamer','Voller Zugriff','Projekte & Kooperationen','Events','Achievement','Punkte bleiben erhalten','Mentor (optional)']
    }
  ];
  return (
    <div className="home-page">
      {/* Hero */}
      <section id="top" className={user ? 'hero-offset-if-sidebar' : ''} style={{ width:'100vw', margin:0, padding:0 }}>
        <h2 className="hero-title" style={{ textAlign:'center', margin:'0 0 8px' }}>Wie funktioniert das AP‑N?</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign:'center', maxWidth:760 }}>
          Klarer Ablauf, echte Unterstützung und smarte Tools: So arbeiten wir gemeinsam –
          transparent, strukturiert und mit Fokus auf nachhaltiges Wachstum.
        </p>
      </section>

      {/* Content */}
      <section style={{ width: '100%', maxWidth: 1100, margin: '0 auto', padding: '0 16px 40px 16px', color: '#fff' }}>
        {/* Überblick */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Überblick</h2>
          <p className="highlight-desc" style={{ display:'flex', alignItems:'flex-start', gap:10 }}>
            <span aria-hidden="true" style={{fontSize:22}}>🧭</span>
            <span>
              AP‑N verbindet <b>Community</b>, <b>Mentoring</b> und <b>Tools</b> in einem strukturierten Prozess.
              Von der Bewerbung über das Onboarding bis hin zu Events und individueller Betreuung –
              jede Phase ist darauf ausgerichtet, dich effektiv zu unterstützen.
            </span>
          </p>
        </div>

        {/* Mitglied werden */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Wie wird man Mitglied im AP‑Network?</h2>
          <p className="highlight-desc" style={{ marginBottom: 10 }}>
            Das AP‑Network ist kein offener Zusammenschluss, sondern ein bewusst ausgewählter Kreis engagierter Creator.
            Wir setzen auf Qualität, Teamgeist und echte gegenseitige Unterstützung – und genau deshalb achten wir sehr
            darauf, wen wir in unsere Community aufnehmen. Mitglied zu sein bedeutet, Teil eines starken Netzwerks zu
            werden, das auf Respekt, Verlässlichkeit und gemeinsamer Weiterentwicklung basiert.
          </p>
          <p className="highlight-desc" style={{ marginBottom: 12 }}>
            Unser Aufnahmeprozess ist transparent, fair und darauf ausgerichtet, sicherzustellen, dass sowohl neue Creator
            als auch die Community langfristig voneinander profitieren.
          </p>
          <div style={{marginTop:4,padding:'10px 12px',border:'1px solid rgba(50,205,137,0.35)',background:'rgba(50,205,137,0.08)',borderRadius:8}}>
            <p style={{margin:0,color:'#d8f5e8'}}>Gemeinsam. Sichtbar. Stark.</p>
          </div>
        </div>

        {/* Ablauf Schritt für Schritt */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Ablauf – Schritt für Schritt</h2>
          <p className="highlight-desc" style={{ marginBottom: 12 }}>
            Von der Bewerbung bis zur Aufnahme: ein klarer, freundlicher Prozess, der beidseitig auf Passung setzt.
          </p>
          <div style={{display:'grid',gap:12,gridTemplateColumns:'1fr'}}>
            {steps.map((s, i) => (
              <div key={i} style={{display:'grid',gridTemplateColumns:'28px 1fr',gap:10,alignItems:'start'}}>
                <div aria-hidden="true" style={{width:28,height:28,borderRadius:999,background:'rgba(255,255,255,0.08)',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:700,color:'#E5E7EB'}}>{i+1}</div>
                <div style={{color:'#D4D8DF'}}>
                  <div style={{fontWeight:700,color:'#E5E7EB'}}>{s.title}</div>
                  <div style={{fontSize:14,marginTop:2}}>{s.desc}</div>
                  {Array.isArray(s.chips) && s.chips.length > 0 && (
                    <div style={{display:'flex',gap:8,flexWrap:'wrap',marginTop:8}}>
                      {s.chips.map((t,ci)=> (
                        <span key={ci} style={{ fontSize:12, lineHeight:'20px', padding:'4px 10px', borderRadius:999, border:'1px solid rgba(255,255,255,0.15)', background:'rgba(255,255,255,0.03)', color:'#D4D8DF' }}>{t}</span>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Rollen & Verantwortlichkeiten */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Rollen & Verantwortlichkeiten</h2>
          <div style={{ display:'grid', gap:12, gridTemplateColumns:'1fr' }}>
            <div className="highlight-desc" style={{ display:'flex', gap:10 }}>
              <span aria-hidden="true" style={{fontSize:20}}>👤</span>
              <span><b>Mitglieder</b> – Produzieren Inhalte, beteiligen sich an der Community, bringen Ideen ein.</span>
            </div>
            <div className="highlight-desc" style={{ display:'flex', gap:10 }}>
              <span aria-hidden="true" style={{fontSize:20}}>🧑‍🏫</span>
              <span><b>Mentoren</b> – Begleiten Creator gezielt mit Erfahrung, Feedback und praktischen Tipps.</span>
            </div>
            <div className="highlight-desc" style={{ display:'flex', gap:10 }}>
              <span aria-hidden="true" style={{fontSize:20}}>🛡️</span>
              <span><b>Moderation</b> – Sichert respektvollen Umgang und Qualität (klare Regeln, transparente Prozesse).</span>
            </div>
            <div className="highlight-desc" style={{ display:'flex', gap:10 }}>
              <span aria-hidden="true" style={{fontSize:20}}>🏗️</span>
              <span><b>Orga/Admin</b> – Infrastruktur, Tools, Events und Weiterentwicklung des Netzwerks.</span>
            </div>
          </div>
        </div>

        {/* Tools & Systeme */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Tools & Systeme</h2>
          <p className="highlight-desc" style={{ display:'flex', alignItems:'flex-start', gap:10, marginBottom:10 }}>
            <span aria-hidden="true" style={{fontSize:22}}>⚙️</span>
            <span>
              Unsere <b>Webanwendung</b> bündelt Automationen, Kommunikation und Organisation: Chats, Events, Punkte/Badges,
              Integrationen, Lurker‑Tools und mehr – alles an einem Ort.
            </span>
          </p>
          <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
            {['Web‑App','Automationen','Integrationen','Lurker‑Tools','Events','Mentoring','Insights'].map((t,i)=> (
              <span key={i} style={{ fontSize:12, lineHeight:'20px', padding:'4px 10px', borderRadius:999, border:'1px solid rgba(255,255,255,0.15)', background:'rgba(255,255,255,0.03)', color:'#D4D8DF' }}>{t}</span>
            ))}
          </div>
        </div>

        {/* Qualität & Fairness */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Qualität & Fairness</h2>
          <p className="highlight-desc" style={{ marginBottom: 10 }}>
            Klare Regeln, transparente Prozesse und verantwortungsvoller Umgang mit Daten – für eine faire, verlässliche und hochwertige Zusammenarbeit.
          </p>
          <div style={{ display:'flex', gap:8, flexWrap:'wrap', marginBottom:12 }}>
            {['Klare Guidelines','Transparente Prozesse','Datenschutz & Sicherheit','Fairness‑Prinzipien','Nachvollziehbare Entscheidungen','Minimaldaten‑Prinzip'].map((t,i)=> (
              <span key={i} style={{ fontSize:12, lineHeight:'20px', padding:'4px 10px', borderRadius:999, border:'1px solid rgba(255,255,255,0.15)', background:'rgba(255,255,255,0.03)', color:'#D4D8DF' }}>{t}</span>
            ))}
          </div>
          <div style={{marginTop:4,padding:'10px 12px',border:'1px solid rgba(50,205,137,0.35)',background:'rgba(50,205,137,0.08)',borderRadius:8}}>
            <p style={{margin:0,color:'#d8f5e8'}}>Respektvoll, sicher, nachvollziehbar: So bleibt Qualität kein Zufall, sondern Standard.</p>
          </div>
        </div>

        {/* Multiplattform‑Prinzip (kurz, Verweis auf About) */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Multiplattform‑Prinzip</h2>
          <p className="highlight-desc">
            Wir unterstützen dich plattformübergreifend und formatagnostisch: Livestreams, Videos, Shorts, Stories –
            bis hin zu realen Events. Details dazu findest du auf der Seite „Über das AP‑Network“.
          </p>
          <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
            <a className="hero-btn-secondary" href="/ueber-ap-network" style={{ padding: '10px 14px', textDecoration:'none' }}>Mehr erfahren</a>
            <a className="hero-btn-secondary" href="/leistungen-im-detail" style={{ padding: '10px 14px', textDecoration:'none' }}>Leistungen im Detail</a>
          </div>
        </div>

        {/* Call to Action */}
        <div className="highlight-card" style={{ padding: 24 }}>
          <h2 className="highlight-title">Jetzt starten</h2>
          <p className="highlight-desc" style={{ marginBottom: 12 }}>
            Klingt gut? Dann bewirb dich oder tritt direkt bei. Wir freuen uns auf dich!
          </p>
          <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
            <a className="hero-btn-primary" href="/register" style={{ padding: '12px 18px', textDecoration:'none' }}>Jetzt beitreten</a>
            <a className="hero-btn-secondary" href="/kontakt" style={{ padding: '12px 18px', textDecoration:'none' }}>Fragen klären</a>
          </div>
          <div style={{ marginTop: 16 }}>
            <a href="#top" style={{ color: '#32CD89' }}>Nach oben</a>
          </div>
        </div>
      </section>
    </div>
  );
}